import { Avatar, AvatarProps } from '@ets/design-system';

/**
 * margin
text
size
color
 */

type GroupAvatarProps = {
  text: string;
} & Pick<AvatarProps, 'size' | 'color'>;

const GroupAvatar = ({ text, size = 'm', color }: GroupAvatarProps) => {
  return (
    <Avatar size={size} color={color} testId={`group-${text}`}>
      {text}
    </Avatar>
  );
};

export default GroupAvatar;
